import Vue from 'vue'
import UserStory from '@/services/UserStory'
import router from '../router'
import store from '../store'

const UserStoryPlugin = {
  install(App) {
    App.prototype.$userStory = new UserStory({ router, store })
  },
}

Vue.use(UserStoryPlugin, {})
